import React from "react";
import "./allInterviewLogsHeader.scss";

const AllInterviewLogsHeader = () => {
  return (
    <div className="all-interview-logs-header">
      <div>
        <h1 className="header-title">All Interview Logs</h1>
        <p className="header-subtitle">
          Comprehensive view of all interview users&apos; interview activities
          and performance
        </p>
      </div>
    </div>
  );
};

export default AllInterviewLogsHeader;

